/*
 * PDP info drawer
 * Un collapsible de la ficha marcado con `open_in_drawer` deja de expandirse
 * inline y abre el panel lateral (#PdpInfoDrawer) con su título y contenido.
 *
 * El listener va en fase de captura sobre document: collapsible-row.js (jQuery)
 * bindea el click directamente sobre `.product-collapsible-row__title`, y
 * detener la propagación en captura impide que ese handler llegue a ejecutarse.
 */
(() => {
  const TRIGGER = '[data-pdp-drawer-trigger]';
  const CLOSER = '[data-pdp-drawer-close]';
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const HISTORY_ID = 'pdp-info-drawer';

  let lastTrigger = null;

  const parts = () => {
    const drawer = document.getElementById('PdpInfoDrawer');
    if (!drawer) return null;
    const panel = drawer.querySelector('.pdp-info-drawer__panel');
    const title = drawer.querySelector('[data-pdp-drawer-title]');
    const body = drawer.querySelector('[data-pdp-drawer-body]');
    if (!panel || !title || !body) return null;
    return { drawer, panel, title, body };
  };

  const isOpen = (drawer) => drawer.getAttribute('aria-hidden') === 'false';

  const open = (trigger) => {
    const el = parts();
    if (!el) return;

    const item = trigger.closest('.product-collapsible-row__item') || trigger.parentElement;
    const tpl = item ? item.querySelector('[data-pdp-drawer-content]') : null;

    el.title.textContent = (trigger.getAttribute('data-pdp-drawer-title') || '').trim();
    el.body.innerHTML = tpl ? tpl.innerHTML : '';
    el.body.scrollTop = 0;

    // El contenido con imagen o encabezado usa la escala editorial (14/22 + H3)
    // en vez del 10/16 del caso "Cuidados". Ver `pdp-info-drawer.css`.
    const editorial = !!el.body.querySelector('img, h1, h2, h3, h4');
    el.drawer.classList.toggle('pdp-info-drawer--editorial', editorial);

    lastTrigger = trigger;
    el.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pdp-info-drawer-open');
    el.panel.focus({ preventScroll: true });

    // El gesto de volver del telefono cierra el panel en vez de salir de la
    // ficha. Ver `ig-overlay-history.js`; sin ese archivo (el setting apagado)
    // el drawer se comporta como siempre.
    if (window.IGOverlayHistory) {
      window.IGOverlayHistory.push(HISTORY_ID, () => close({ fromHistory: true }));
    }
  };

  const close = (options) => {
    const el = parts();
    if (!el || !isOpen(el.drawer)) return;
    el.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pdp-info-drawer-open');
    if (window.IGOverlayHistory && !(options && options.fromHistory)) {
      window.IGOverlayHistory.pop(HISTORY_ID);
    }
    if (lastTrigger) {
      const target = lastTrigger;
      lastTrigger = null;
      if (typeof target.focus === 'function') target.focus({ preventScroll: true });
    }
  };

  const trapTab = (event, panel) => {
    const items = Array.prototype.filter.call(
      panel.querySelectorAll(FOCUSABLE),
      (node) => node.offsetParent !== null || node === document.activeElement
    );
    if (!items.length) {
      event.preventDefault();
      panel.focus({ preventScroll: true });
      return;
    }
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest(CLOSER)) {
        event.preventDefault();
        event.stopPropagation();
        close();
        return;
      }

      const trigger = target.closest(TRIGGER);
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      const el = parts();

      if (event.key === 'Escape' && el && isOpen(el.drawer)) {
        event.preventDefault();
        event.stopPropagation();
        close();
        return;
      }

      if (event.key === 'Tab' && el && isOpen(el.drawer)) {
        trapTab(event, el.panel);
        return;
      }

      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      const target = event.target instanceof Element ? event.target : null;
      const trigger = target ? target.closest(TRIGGER) : null;
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open(trigger);
    },
    true
  );
})();
